import {useParams, useSearchParams} from 'react-router-dom';

import {PersonnelDocumentTitle} from 'src/app/personnel/personnelHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {
  ModuleEnum,
  PermissionOperationEnum,
  UserTypeEnum,
} from 'src/api/ProactApiClient';
import type {PersonnelViewType} from 'src/shared/constants/ViewTypes';
import {PersonnelForm} from 'src/app/personnel/PersonnelForm/PersonnelForm';
import type {ViewModeType} from 'src/shared/services/RouterService/IRouteService';
import {VendorListPersonnelRouteService} from 'src/shared/services/RouterService/VendorListPersonnelRouteService';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const VendorPersonnelListEditPage = () => {
  useSetDocumentTitle(PersonnelDocumentTitle);
  const {personnelId, view} = useParams();
  const [searchParams] = useSearchParams();

  const fromTabParam = searchParams.get('from');
  const fromTab = fromTabParam === 'all' ? 'all'
    : fromTabParam === 'activity' ? 'activity'
    : 'vendor' as const;

  const mode: ViewModeType = 'edit';
  const router = new VendorListPersonnelRouteService(false, mode, {
    view: view as PersonnelViewType,
    fromTab,
  });

  return (
    <PersonnelForm
      mode={mode}
      userType={UserTypeEnum.Contractor}
      id={+personnelId!}
      view={view as PersonnelViewType}
      enableEdit={true}
      router={router}
    />
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.VendorListPersonnelEdit(':personnelId', ':view'),
  element: <VendorPersonnelListEditPage />,
  module: ModuleEnum.Personnel,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});

export default VendorPersonnelListEditPage;
